import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface FilterMenuPopoverOption {
  key: string;
  label: string;
  iconClass?: string;
  visible?: any;
}

@Component({
  selector: 'app-filter-menu-popover',
  templateUrl: './filter-menu-popover.component.html',
})
export class FilterMenuPopoverComponent {
  @Input() options: FilterMenuPopoverOption[] = [];
  @Input() selectedKey: string;
  @Input() defaultKey = 'showAll';
  @Input() titleLabel: string;
  @Input() currentIconClass: string;

  @Output() selectionChange = new EventEmitter<string>();

  getLabel(key: string): string {
    const item = this.options.find(t => t.key === key);
    return item ? item.label : '';
  }

  selectFilter(key: string) {
    this.selectionChange.emit(key);
  }
}
